export default __webpack_public_path__ + "static/media/Nuestros_valores_2.78636355.png";